import { trackPixleeActions, utagViewArtificialPageView } from 'features/tealium';

const PixleeWidgetEvent = ({ type, data }) => {

	const eventData = { ...data, uid: 'd284fb3c-5c29-a87h-ed71-8ce230h8e50' };

	if (typeof window.pixlee_analytics !== 'undefined') {

		window.pixlee_analytics.events.trigger(type, eventData);

	}

};

const pixleeUGCEvents = trackPixleeActions();

const UGCEvent = (props) => {

	pixleeUGCEvents(props);

};

const trackArtificialPageView = utagViewArtificialPageView();

const ArtificialPageEvent = (props) => {

	trackArtificialPageView(props);

};

export { PixleeWidgetEvent, UGCEvent, ArtificialPageEvent };
